import { PublicClientApplication } from '@azure/msal-browser';

export let externalMsalInstance: PublicClientApplication | null = null;

export function setExternalMsalInstance(instance: PublicClientApplication) {
  externalMsalInstance = instance;
}
